<template>
  <div class="report">
    <div class="export_wrap" >
      <el-button style="color: #124E91" link icon="Download" @click="usePrintJS" :loading="loading">下载报告</el-button>
    </div>
    <div class="content_wrap" v-loading="loading" >
      <div class="content" ref="exportArea"  id="export-area"  >
        <page1 :name="name"></page1>
        <div class="page-break"></div> <!-- 分页符 -->
        <page2 :data="echartsInfo"></page2>
        <div class="page-break"></div> <!-- 分页符 -->
        <page3 :data="echartsInfo"></page3>
        <div class="page-break"></div> <!-- 分页符 -->
        <page4 :data="echartsInfo"></page4>
        <div class="page-break"></div> <!-- 分页符 -->
        <page5 :data="echartsInfo"></page5>
        <div class="page-break"></div> <!-- 分页符 -->
        <page6></page6>
        <div class="page-break"></div> <!-- 分页符 -->
        <page7></page7>
        <div class="page-break"></div> <!-- 分页符 -->
        <page8></page8>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref,onMounted,reactive} from "vue";
import page1 from './printPage/page1.vue'
import page2 from './printPage/page2.vue'
import page3 from './printPage/page3.vue'
import page4 from './printPage/page4.vue'
import page5 from './printPage/page5.vue'
import page6 from './printPage/page6.vue'
import page7 from './printPage/page7.vue'
import page8 from './printPage/page8.vue'
import organizationApi from "@/api/organization";
import usePrintJS from './printPage/printList.js'

const exportArea = ref(null);
const loading = ref(false); // 加载状态
const props = defineProps({
  organizationId: {
    type: String,
    default: '',
  },
  name:{
    type:String,
    default:'' 
  }
});

const echartsInfo = reactive({
  totalInfo: {
    effectiveProportion: 0, //总的参评占比
    totalProportion: 0, //测评有效占比
    femaleSexCount: 0, //女性
    maleSexCount: 0,  //男性
    multipleCount: 0, //重复测评人数
  },
  organizationResultList: [],//预警情况
  comprResultList: [],//身心健康
  sexResultList: [],
  indicatResultList: [],
  mshasResultList: [],
  energyResultList: [],//情绪能量
  tableResultList: [],//心理指标统计
  healthResultList: [],//健康值指标统计
  brainResultList: [],//大脑疲劳度
  concentResultList: [],//集中度
  indicatorResultList: [],//心理状态指标统计
  vitalityResultList: [],//活力度指标统计
  ageResultList: [],//年龄统计
  mshasOrgResultList: [],  //组织心理状态预警
  compreOrgResultList: [], //组织身心健康预警
  comprehensiveResultList: [], //综合预警
})

const emits = defineEmits(["rendomEachart"]);
onMounted(() => {
  // exportPDF();
  loading.value = true 
  organizationApi.downloadReport({organizationId:props.organizationId}).then((res) => {
    echartsInfo.organizationResultList = res.data.organizationResultList || []
    echartsInfo.comprResultList = res.data.comprResultList || []
    echartsInfo.sexResultList =res.data.sexResultList || []
    echartsInfo.indicatResultList = res.data.indicatResultList || []
    echartsInfo.mshasResultList = res.data.mshasResultList || []
    echartsInfo.energyResultList = res.data.energyResultList || []
    echartsInfo.tableResultList = res.data.tableResultList || []
    echartsInfo.healthResultList = res.data.healthResultList || []
    echartsInfo.brainResultList  = res.data.brainResultList || []
    echartsInfo.concentResultList  = res.data.concentResultList || []
    echartsInfo.indicatorResultList  = res.data.indicatorResultList || []
    echartsInfo.vitalityResultList  = res.data.vitalityResultList || []
    echartsInfo.ageResultList  = res.data.ageResultList || []
    echartsInfo.compreOrgResultList  = res.data.compreOrgResultList || []
    echartsInfo.mshasOrgResultList  = res.data.mshasOrgResultList || []
    echartsInfo.comprehensiveResultList  = res.data.comprehensiveResultList || []

    echartsInfo.totalInfo.effectiveProportion = res.data.effectiveProportion?res.data.effectiveProportion:0
    echartsInfo.totalInfo.totalProportion = res.data.totalProportion?res.data.totalProportion:0
    echartsInfo.totalInfo.femaleSexCount = res.data.femaleSexCount?res.data.femaleSexCount:0
    echartsInfo.totalInfo.maleSexCount = res.data.maleSexCount?res.data.maleSexCount:0
    echartsInfo.totalInfo.multipleCount = res.data.multipleCount?res.data.multipleCount:0
    loading.value = false
    emits("rendomEachart");
    console.log(136,echartsInfo.mshasResultList)
  }).catch(()=>{
    loading.value = false
  })
});
</script>

<style scoped lang="scss">
.report{
  height: 90vh;
  overflow: auto;
}
.export_wrap{
  text-align: right;
  padding: 10px;
}
.printBox {
  width: 210mm !important;/* A4 宽度 */
  height: 297mm !important;/* A4 高度 */
  margin: 0 auto !important;
  overflow: hidden;
  page-break-inside: avoid;/* 禁止分页切割 */
}
</style>